import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Recruitment } from "@/components/Recruitment";
import { DiscoveryModal } from "@/components/DiscoveryModal";
import { Seo } from "@/components/Seo";

const openDiscovery = () => window.dispatchEvent(new CustomEvent("open-discovery"));

export const RecruitmentPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FAFBF7]">
      <Seo
        title="Recruitment Services | XSELL Solutions"
        description="Cross-functional recruitment services by XSELL Solutions — engineering, product, operations, leadership and sales hiring on a success-based placement model with a replacement guarantee."
        path="/recruitment"
      />

      {/* top bar */}
      <header className="sticky top-0 z-50 border-b border-line bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/" data-testid="recruit-page-logo" className="flex items-center">
            <img src="/xsell-logo-light.png" alt="XSELL Solutions" className="h-10 w-auto" />
          </Link>
          <button
            type="button"
            onClick={openDiscovery}
            data-testid="recruit-page-cta"
            className="inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-ink-950 transition-colors hover:bg-brand-hover"
          >
            Book a Discovery Call <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </header>

      <div className="mx-auto max-w-6xl px-6 pt-10">
        <Link
          to="/"
          data-testid="recruit-page-back"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#5C8A1E] transition-colors hover:text-[#4a7418]"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
      </div>

      <Recruitment showLink={false} />

      <footer className="border-t border-line py-8">
        <div className="mx-auto max-w-6xl px-6 text-center text-xs text-[#8e9882]">
          © {new Date().getFullYear()} XSELL Solutions — GTM & Revenue Consulting.
        </div>
      </footer>

      <DiscoveryModal />
    </div>
  );
};
